import { useEffect } from "react";
const PageNotFound = () => {
    useEffect(() => {
        throw new Error("Invalid URL");
    }, []);
    return null;
};
export default PageNotFound;
